module.exports = __webpack_public_path__ + "img/home-cup.d637f7c6.svg";